import CommonError from '../Common/CommonError'

const Error403Container = () => {
  return (
    <CommonError error="403" color="success" src="sad" />
  )
}

export default Error403Container